import { getControlItem, updateVideoTime } from '../utils/helpers'
import { CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class VideoTime extends Controls {
  private updateProgressBar: boolean

  constructor({
    element,
    videoPlayer,
    wrapperElement,
    updateProgressBar,
  }: {
    element: HTMLElement
    videoPlayer: HTMLVideoElement
    wrapperElement: HTMLDivElement
    updateProgressBar: boolean
  }) {
    super(element, videoPlayer, wrapperElement)
    this.updateProgressBar = updateProgressBar

    this.renderVideoTime()
  }

  private renderVideoTime() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'div',
          classes: [CONTROL_CLASS, 'cmp-video-time'],
        },
        children: [
          { element: 'span', classes: ['cmp-video-time__current'], text: '0:00' },
          { element: 'span', classes: ['cmp-video-time__divider'], text: '/' },
          { element: 'span', classes: ['cmp-video-time__duration'], text: '-:-' },
        ],
        eventListenerElement: this.videoPlayer,
        eventListeners: ['timeupdate', 'progress'],
        callback: e => updateVideoTime(e, this.wrapperElement, this.updateProgressBar),
      }),
    )
  }
}
